import { jsx, jsxs } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { cn } from "../../../common/helpers/common.utils.js";
import { forwardRef } from "react";
import "../../../loaders/components/CircularProgress/CircularProgress.js";
import LinearProgress from "../../../loaders/components/LinearProgress/LinearProgress.js";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./Table.module.scss.js";
const tableVariants = cva([styles["app-table"], "table rounded-lg bg-card-color w-full h-full text-sm"], {
  variants: {
    borderStyle: {
      default: [styles["table-default"]],
      divider: [styles["table-divider"]],
      full: [styles["table-bordered"]]
    },
    hover: {
      true: styles["table-hover"],
      false: ""
    }
  },
  defaultVariants: {
    borderStyle: "default",
    hover: false
  }
});
const TableRow = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ jsx("tr", { ...rest, ref, className: twMerge(styles["app-tr"], className), children });
});
const TableCell = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ jsx("td", { ...rest, ref, className: twMerge(styles["app-td"], "font-medium align-middle p-5", className), children });
});
const Table = (props) => {
  const {
    data,
    columns,
    renderRow,
    borderStyle,
    hover,
    className,
    height,
    isLoading,
    stickyHeader,
    fallback = "No data found",
    ...rest
  } = props;
  return /* @__PURE__ */ jsx("div", { className: "overflow-x-auto overflow-y-auto rounded-lg", style: { height }, children: /* @__PURE__ */ jsxs("table", { ...rest, className: twMerge(tableVariants({ borderStyle, hover, className })), children: [
    /* @__PURE__ */ jsx("thead", { className: styles["app-thead"], children: /* @__PURE__ */ jsx(TableRow, { children: columns.map((column, i) => /* @__PURE__ */ jsx(
      "th",
      {
        className: cn(
          styles["app-th"],
          "align-middle p-5 font-normal text-grayscale-500 text-xs text-left",
          stickyHeader && "sticky top-0 z-[1]"
        ),
        children: column.header
      },
      i
    )) }) }),
    /* @__PURE__ */ jsxs("tbody", { className: styles["app-tbody"], children: [
      isLoading && /* @__PURE__ */ jsx(TableRow, { className: styles["no-hover"], children: /* @__PURE__ */ jsxs(TableCell, { colSpan: columns.length, className: "text-center text-grayscale-500 py-10", children: [
        /* @__PURE__ */ jsx(LinearProgress, { color: "primary", className: "max-w-[220px] mx-auto" }),
        /* @__PURE__ */ jsx("div", { className: "mt-3", children: "Loading..." })
      ] }) }),
      !isLoading && data.map(
        (row, dataIndex) => renderRow ? renderRow(row, dataIndex) : /* @__PURE__ */ jsx(TableRow, { children: columns.map((col, colIndex) => /* @__PURE__ */ jsx(TableCell, { children: col == null ? void 0 : col.cell(row, dataIndex) }, colIndex)) }, row._id || (row == null ? void 0 : row.id))
      ),
      !isLoading && data.length === 0 && /* @__PURE__ */ jsx(TableRow, { className: styles["no-hover"], children: /* @__PURE__ */ jsx(TableCell, { colSpan: columns.length, className: "text-center text-grayscale-500 py-10", children: fallback }) })
    ] })
  ] }) });
};
Table.Row = TableRow;
Table.Cell = TableCell;
export {
  Table as default
};
//# sourceMappingURL=Table.js.map
